module.exports = "/_next/static/images/microsalts_banner-3d42704d5de3a6b8ae22ec7d8d76c733.png";